import React from "react"
import "./article-audio.scss"
import iconSpotify from "../../../assets/images/article-audio/iconSpotify.png"

import AudioPlayer from "react-h5-audio-player"

const ArticleAudio = props => {
  const { audioContent } = props

  return (
    <>
      <div className="f-article-audio">
        {audioContent.podcast && ( //url mp3 de cms
          <div className="f-article-audio__info">
            <p className="f-article-audio__info__title">
              Escucha este Artículo
            </p>
            <div className="f-article-audio__info__reproductor">
              <AudioPlayer src={audioContent.podcast.file.url} />
            </div>
          </div>
        )}
        {audioContent.urlPodcast && ( //url spotify.
          <div className="f-article-audio__button">
            <a
              href={audioContent.urlPodcast}
              target="_blank"
              rel="noopener noreferrer"
            >
              Escuchar en Spotify <img src={iconSpotify} alt="spotify logo" />
            </a>
          </div>
        )}
      </div>
    </>
  )
}

export default ArticleAudio
